import { useRouter } from "next/router";

/**
 * 콜 유효율이 낮은 페이지에서 전화 CTA를 숨긴다.
 *
 * 근거: 노션 "전화 콜 페이지별 유효율"(2026-09, 2026-01-01~09-03 집계).
 * 전체 콜 유효율 18.3%, 콜당 장례 20.3건이 기준선이다.
 *
 * | 페이지                              | 콜  | 유효율 | 장례 |
 * | /guidebook/tip/etc/closed-funeral/ |  41 |  4.9% |   0 |
 * | /facilities/[id]/                  | 586 |  8.2% |  10 |
 * | /information-price/facility/[id]/  |  65 | 10.8% |   3 |
 * | /match/facility-requests/[id]/     |  55 |  7.3% |   3 |
 * | /facility-relocate/[id]/           |  26 | 15.4% |   0 |
 *
 * 장지 추천 결과(/match/facility-recommendation/)는 노션 표에 없어 위 기준과 별개로 추가했다.
 * 로그인 이후 화면이라 전화 리드의 페이지 귀속이 8개월간 1건뿐이라 유효율을 측정할 수 없다.
 * 대신 GA4 기준 goi_call 920건, 방문자 대비 발화율 37.0%(전 페이지 최고)로 콜 유입량이 크다.
 * 관련 실험 #336, #324 는 모두 종료됐다.
 *
 * 롤백: HIDE_CALL_CTA_ENABLED 를 false 로 바꾸면 전부 원복된다.
 * 일부만 되돌리려면 아래 목록에서 해당 줄만 지우면 된다.
 */
export const HIDE_CALL_CTA_ENABLED = true;

/**
 * 라우트 단위로 숨기는 페이지. next router.pathname 과 정확히 일치해야 한다.
 * pathname 은 SSR/CSR 값이 같아서 하이드레이션 불일치가 없다.
 */
const HIDDEN_PATHNAMES = [
  "/facilities/[id]",
  "/information-price/facility/[id]",
  "/match/facility-requests/[id]",
  "/facility-relocate/[id]",
  "/match/facility-recommendation",
];

/**
 * 가이드북 tip 은 라우트가 `/guidebook/tip/[category]/[index]` 하나라 글 단위로 지정한다.
 * 상조 폐업 글만 대상이고 다른 tip 글은 그대로 둔다.
 *
 * router.query 는 SSG 하이드레이션 전에 비어 있어 쓰지 않는다. asPath 로 판정하는 것은
 * 같은 파일군의 Layout `isHeaderHidden` 이 이미 쓰는 방식이다.
 */
const HIDDEN_ASPATH_PREFIXES = ["/guidebook/tip/etc/closed-funeral"];

/**
 * 현재 페이지에서 전화 CTA를 숨겨야 하는지 여부.
 *
 * 전화 CTA를 렌더하는 쪽에서 이 훅 하나만 통과시키면 된다. 공유 컴포넌트
 * (Header, PlatformAdvancePayPackageCardBanner)도 라우트로 판정하므로 prop 을 흘릴 필요가 없다.
 */
export const useHideCallCta = () => {
  const { pathname, asPath } = useRouter();

  if (!HIDE_CALL_CTA_ENABLED) return false;

  return (
    HIDDEN_PATHNAMES.includes(pathname) ||
    HIDDEN_ASPATH_PREFIXES.some((prefix) => asPath.startsWith(prefix))
  );
};
